import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

import { environment } from 'src/environments/environment';
import { EntityService } from './entity.service';
import { formatDate as formatDateUtil } from '../utils/dates.utils';


@Injectable({ providedIn: 'root' })
export class CatalogSuggestionsService {
  private _catalogSuggestionsData$ = new BehaviorSubject<any>(null);
  public readonly catalogSuggestionsData = this._catalogSuggestionsData$.asObservable();

  _user$: any;

  constructor(private http: HttpClient,
    private authService: AuthService,
    private entityService: EntityService) {
    this.authService.user$.subscribe((user: any) => this._user$ = user)
  }

  // TODO: this will need some significant updates once express updates their endpoint. for example, we no longer handle time or dates like this, there is no cost, description, or credit hours field,
submitCatalogSuggestion = (catalogSuggestion: any) => {
  const formatTime = (time: any) => {
    const newTime = new Date(time);
    newTime.toLocaleTimeString();
    let hours = '' + newTime.getHours();
    let minutes = '' + newTime.getMinutes();
    if (hours.length < 2)
      hours = '0' + hours;
    if (minutes.length < 2)
      minutes = '0' + minutes;
    return [hours, minutes].join(':');
  }

  const timezone = this.entityService.getLocalTimezone();

  if (catalogSuggestion?.startTime) {
    if (catalogSuggestion?.startTime?.length > 5) {
      const formattedStartTime = formatTime(catalogSuggestion?.startTime);
      catalogSuggestion.startTime = formattedStartTime;
    }
    const courseDateStr = formatDateUtil.formatDateOnly(catalogSuggestion.courseDate, timezone);
    if (courseDateStr) {
      const [hours, minutes] = catalogSuggestion.startTime.split(':');
      // Send as naive datetime - backend will interpret as UTC (wall clock time)
      const dateTimeStr = `${courseDateStr}T${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
      catalogSuggestion.sessionStartDate = dateTimeStr;
    }
  }

  if (catalogSuggestion?.endTime) {
    if (catalogSuggestion?.endTime?.length > 5) {
      const formattedEndTime = formatTime(catalogSuggestion?.endTime);
      catalogSuggestion.endTime = formattedEndTime;
    }
    const courseDateStr = formatDateUtil.formatDateOnly(catalogSuggestion.courseDate, timezone);
    if (courseDateStr) {
      const [hours, minutes] = catalogSuggestion.endTime.split(':');
      // Send as naive datetime - backend will interpret as UTC (wall clock time)
      const dateTimeStr = `${courseDateStr}T${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
      catalogSuggestion.sessionEndDate = dateTimeStr || null;
    }
  }

  const itemsArray: any = {
    'location': catalogSuggestion.location,
    'regStartDate': new Date().toISOString(),
    'regEndDate': new Date().toISOString(),
    'courseSize': 1,
    'allowWaitListFlag': 0,
    'instructorId': null,
  };

  if (catalogSuggestion.async) {
    itemsArray.preRecordedOption = 'ASYNC';
  } else if (catalogSuggestion.anytime) {
    itemsArray.preRecordedOption = 'ANYTIME';
  } else {
    if (catalogSuggestion.courseDate) {
      itemsArray.dateOffered = formatDateUtil.formatDateOnly(catalogSuggestion.courseDate, timezone);
    }
    if (catalogSuggestion.sessionStartDate) {
      itemsArray.sessionStartDate = catalogSuggestion.sessionStartDate;
    }
    if (catalogSuggestion.sessionEndDate) {
      itemsArray.sessionEndDate = catalogSuggestion.sessionEndDate;
    }
  }

  if (catalogSuggestion.instructor) {
    itemsArray.instructor = catalogSuggestion.instructor;
  }
  if (catalogSuggestion.roomNumber) {
    itemsArray.roomNumber = catalogSuggestion.roomNumber;
  }
  if (catalogSuggestion.webUrl) {
    itemsArray.hyperlink = catalogSuggestion.webUrl;
  }
  if (catalogSuggestion.virtual) {
    itemsArray.virtualFlag = 1;
  }

  const formattedCatalogSuggestion: any = {
    'loginName': this._user$.loginName,
    'courseName': catalogSuggestion.name,
    'courseTypeId': parseFloat(catalogSuggestion.courseTypeObject.id),
    'trackingValue': parseFloat(catalogSuggestion.creditHours),
    'courseCost': parseFloat(catalogSuggestion.cost),
    'courseDescription': catalogSuggestion.description,
    'approvalId': parseFloat(catalogSuggestion.approvalId),
    'validationId': parseFloat(catalogSuggestion.validationId),
    'itemsArray': [itemsArray],
  };

  return this.http.post(
    `${environment.expressUrl}/courses/catalog-suggestions`,
    formattedCatalogSuggestion,
    { headers: { 'Content-Type': 'application/vnd.api+json' } },
  )
}

  // we use this call to show the catalog suggestion details in the profile page:catalog-suggestions tab. currently we call it with AllCourseDetails, but we may be able to narrow that if needed.
  getCatalogSuggestion = (CatalogSuggestionId: any) => {
    return this.http.get(`${environment.expressUrl}/courses/catalog-suggestions/${CatalogSuggestionId}`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        params: { loginName: this._user$.loginName, includedAssociations: 'AllCourseDetails' },
      })
  }


  // we use this call to show the catalog suggestion list in the profile page:catalog-suggestions tab
// Update the getUserCatalogSuggestions method in catalog-suggestions.service.ts

getUserCatalogSuggestions = (otherUsersId?: any, additionalParameters?: any) => {
  return this.http.get(`${environment.expressUrl}/courses/registration/pd-plan`,
    {
      headers: { 'Content-Type': 'application/vnd.api+json' },
      params: {
        loginName: this._user$.loginName,
        specialRequestFlag: 0,
        userId: otherUsersId ? otherUsersId : this._user$.id,
        ...additionalParameters,
      },
    })
    .subscribe({
      next: (response: any) => {
        // FIX: The /pd-plan endpoint returns catalog suggestions in data.catalogSuggestions
        // not in data.rows. We need to normalize the response structure.
        
        console.log('[CatalogSuggestionsService] Raw response from pd-plan:', response);
        
        if (response.data && response.data.catalogSuggestions) {
          // Transform the response to match the expected structure
          const normalizedResponse = {
            ...response.data,
            rows: response.data.catalogSuggestions, // Map catalogSuggestions to rows
            counts: response.data.counts || { activeCount: 0, inactiveCount: 0 },
            pagination: response.data.pagination || {
              curPage: 1,
              totalPages: 0,
              totalItems: 0,
              totalPerPage: additionalParameters?.limit || 25
            },
            links: response.data.links || {}
          };
          
          console.log('[CatalogSuggestionsService] Normalized data:', normalizedResponse);
          this._catalogSuggestionsData$.next(normalizedResponse);
        } else {
          // If no catalogSuggestions, emit the original response
          this._catalogSuggestionsData$.next(response.data);
        }
      },
      error: (error) => {
        console.log('error', error);
      },
    })
}

  // we use this call to show the catalog suggestion list in the Manage Courses:catalog-suggestions tab
  getManagedCatalogSuggestions = ( additionalParameters?: any) => {
    return this.http.get(`${environment.expressUrl}/courses/catalog-suggestions`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        params: {
          loginName: this._user$.loginName,
          ...additionalParameters,
        },
      })
      .subscribe({
        next: (response: any) => {
                  console.log('[CatalogSuggestionsService] response from /courses/catalog-suggestions:', response);
          this._catalogSuggestionsData$.next(response.data);
        },
        error: (error) => {
          console.log('error', error);
        },
      })
  }

  // this clears the catalog suggestions data in the Manage Courses:catalog-suggestions tab
  clearcatalogSuggestionsData = () => {
    this._catalogSuggestionsData$.next(null);
  }

// this is used to deny a catalog suggestion
denyCatalogSuggestion = (catalogSuggestion: any, denialReason: any) => {
  return this.http.patch(
    `${environment.expressUrl}/courses/catalog-suggestions/${catalogSuggestion.courseId}/reject`,
    {
      loginName: this._user$.loginName,
      courseItemId: parseFloat(catalogSuggestion.courseItemId), 
      comment: denialReason || '',
      messageBody: denialReason || '', 
    },
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/json',
      },
      params: { includedAssociations: 'AllCourseDetails' },
    },
  );
};



  approveCatalogSuggestion = (catalogSuggestion: any, catalogSuggestionId?: any) => {
    return this.http.patch(
      `${environment.expressUrl}/courses/catalog-suggestions/${catalogSuggestion.courseId}/approve`,
      {
        loginName: this._user$.loginName
      },
      { 
        headers: { 
          'Content-Type': 'application/vnd.api+json',
          'Accept': 'application/json'
        } 
      },
    )
  }

// this is used to approve a catalog suggestion
// this is used to approve a catalog suggestion
approveCatalogSuggestions = (
  courseChanges: any,
  userId: any,
  courseId: any,
  courseItemId: any,
  messageBody?: string,
) => {
  // keep this if you want, but it doesn't matter if you're not sending courseChanges
  if (courseChanges?.courseCost) {
    courseChanges.courseCost = courseChanges.courseCost.toString();
  }

  return this.http.patch(
    `${environment.expressUrl}/courses/catalog-suggestions/${courseId}/approve`,
    {
      loginName: this._user$.loginName,
      messageBody: messageBody || '',
    },
    {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/json',
      },
      params: { includedAssociations: 'AllCourseDetails' }, // optional, but matches what you're calling
    },
  );
};



  // used when the user wants to cancel a catalog suggestion they created
  removeCatalogSuggestion = (courseId: any) => {
    return this.http.delete(`${environment.expressUrl}/courses/catalog-suggestions/${courseId}`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        body: { 'loginName': this._user$.loginName },
      })
  }
}
